import React, { useEffect, useState } from 'react';
import Loader from '../../../common/Loader';
import { useFetchCheckbetTicket } from '../../../data/fetchCheckbetTicket';
import { getLabel } from '../../../data/labels';
import BetInfo from './BetInfo';
import EventsList from './EventsList';
import ToggleNotifications from '../my-bets-layout-3/ToggleNotifications';
import { getConfiguration } from '../../utils/configuration';
import { formatDate } from '../../utils/formatDate';
import { getEnv } from '../../env';
import { getStatusBadgeMod } from '../../utils/getStatusBadgeMod';
import { getTicketCategoryLabel } from '../../utils/getTicketCategorylabel';

function SingleBetTicketDetail(props) {
    const [data, setData] = useState(null);
    const [state, dispatch] = useFetchCheckbetTicket(props.ticket.id, true, props.ticket.isLive, false, true);
    const conf = getConfiguration();

    useEffect(() => {
        if (state.data != null && !state.isError) setData(state.data);
    }, [state.data, state.isError]);

    if (state.isLoading) return <Loader />;
    if (data == null) return <Loader error={true} />;

    return (
        <div className="mybet-events-container | mb_6">
            {conf.pnc?.enabled && <ToggleNotifications state={state} dispatch={dispatch} />}
            <EventsList events={data.events} isBetBuilder={data.betBuilder} isCheckbet={false} />
        </div>
    );
}

function SingleBetTicket(props) {
    const conf = getConfiguration()
    function toggleMatches() {
        props.toggleTicket(props.ticket.id);
    }

    return (
        <div className="mybet-container d-flex flex-column | mb_5">

            {conf.ebv2r ? (
                <div className="sc__ticket-header | mb_5_1" onClick={toggleMatches}>
                    <span className={`sc__status-badge ${getStatusBadgeMod(props.ticket.status)}`}>
                        {getTicketCategoryLabel(props.ticket.status)}
                    </span>
                    <span className="sc__ticket-type | mb_5_1_1">
                        {getLabel('mybets.singola').toUpperCase()}
                        {props.ticket.funBonus &&
                            <span className="cg-mybet-funbonus sc__ticket-badge | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                        }
                        {props.ticket.freeBet &&
                            <span className="cg-mybet-funbonus sc__ticket-badge | mb_5_1_2_3">{getLabel('mybets.freebet')}</span>
                        }
                        {props.ticket.isBetBuilder &&
                            <span className="cg-mybet-funbonus sc__ticket-badge | mb_5_1_2_3">{getLabel('betbuilder.title')}</span>
                        }
                    </span>
                    <span className="sc__ticket-date">
                        {formatDate(props.ticket.timestamp).formatted}
                    </span>
                    <img
                        src={`${getEnv('PUBLIC_URL')}/assets/images/arrow.svg`}
                        alt=""
                        className={`sc__ticket-chevron ${props.toggled ? 'sc__ticket-chevron--up' : ''}`}
                    />
                </div>
            ) : (
                <div
                    className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1"
                    onClick={toggleMatches}
                >
                    <span className="text-big bold | mb_5_1_1">{getLabel('mybets.singola')}</span>
                    <span className="margine-sx margin-right-auto | mb_5_1_2">
                        {props.ticket.funBonus &&
                            <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                        }
                        {props.ticket.freeBet &&
                            <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('mybets.freebet')}</span>
                        }
                        {props.ticket.isBetBuilder &&
                            <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('betbuilder.title')}</span>
                        }
                    </span>
                    <span className="mb_5_1_3" onClick={toggleMatches}>
                        {`${getLabel('mybets.dettagli')} ${props.toggled ? '-' : '+'}`}
                    </span>
                </div>
            )}

            <hr className="mb_4" />
            {props.toggled && <SingleBetTicketDetail ticket={props.ticket} />}
            <div className="light-grey-bg | mb_5_3">
                <BetInfo ticket={props.ticket} isCheckbet={false} />
            </div>
        </div>
    );
}

export default SingleBetTicket;